module.exports = __webpack_public_path__ + "static/media/Autumn-Park-Bylaws-Novi.c0c468a8.pdf";